// client/src/hooks/usePlataformaGoogleLogin.js
// Client ID do "Entrar com Google" pro cliente final (site/conta) —
// configurado pela matriz. Espelha usePlataformaGoogleNegocio.js.
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

export const usePlataformaGoogleLoginConfig = () => useQuery({
    queryKey: ['plataforma-google-login', 'config'],
    queryFn: () => apiClient.get('/plataforma-google-login/config').then((r) => r.data.data),
});

export const useSalvarPlataformaGoogleLoginConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.put('/plataforma-google-login/config', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-google-login', 'config'] });
            setAlert('Configuração de login com Google salva com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao salvar configuração de login com Google.'), 'danger'),
    });
};
